import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect } from 'react'
import Modal from 'react-modal';
import UserService from '../../../services/UserService';


const User: FC<any> = observer(data => {
    const { user, index, setFix } = data;
    const [userData, setUserData] = useState({'name': '', 'email': '', 'is_superuser': false, 'is_active': false, 'is_staff': false});
    useEffect(() => {
        setUserData({'name': user['name'], 'email': user['email'], 'is_superuser': user['is_superuser'], 'is_active': user['is_active'], 'is_staff': user['is_staff']});
    }, [user]);

    const saveData = async () => {
        await UserService.updateUsersFull(user['id'], userData);
        setFix(true);
    }

    const delUser = async () => {
        await UserService.delUser(user['id']);
        setFix(true);
    }
    
    return (
        <tr>
            <th scope="row">{index + 1}</th>
            <td>{userData['name']}</td>
            <td>{userData['email']}</td>
            <td><input type="checkbox" checked={userData['is_superuser']}
                       onChange={() => setUserData({...userData, 'is_superuser': !userData['is_superuser']})}/></td>
            <td><input type="checkbox" checked={userData['is_active']}
                       onChange={() => setUserData({...userData, 'is_active': !userData['is_active']})}/></td>
            <td><input type="checkbox" checked={userData['is_staff']}
                       onChange={() => setUserData({...userData, 'is_staff': !userData['is_staff']})}/></td>
            <td>
                <i className='icon save' onClick={() => saveData()}/>
                <i className='icon trash' onClick={() => delUser()}/>
            </td>
        </tr>
    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const UsersModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const [users, setUsers] = useState([]);
    const [fix, setFix] = useState(true);

    const getUA = async () => {
        const qa = await UserService.getUsersFull();
        setUsers(qa.data.results);
    };

    useEffect(() => {
        getUA();
        setFix(false);
    }, [fix, toggle]);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getUsers = () => users.map((user: any, index: number) => {
        return <User key={user['id']} {...{ user, index, setFix }} />
    })

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="co-md-1">№</th>
                                <th scope="col-md-3">Имя</th>
                                <th scope="col-md-3">Email</th>
                                <th scope="col-md-1">Суперпользователь?</th>
                                <th scope="col-md-1">Активирован?</th>
                                <th scope="col-md-1">Специалист?</th>
                                <th scope="col-md-2">Управление</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getUsers()}
                        </tbody>
                    </table>

                </div>
            </form>
        </Modal >
    );
});